jQuery(document).ready(function ($) {
  $('body').on('click', '#box-shipping', function(e){
       e.preventDefault();
       shopify_toggle_shipping_country();
   });
});

const getListCurrenciesBox = () => {
  const currencies_update  = window.localStorage.getItem('currencies_country');
  const shipping_local  = JSON.parse(window.localStorage.getItem('shipping_local'));
  let check_local;
  if(currencies_update) {
    check_local = currencies_update;
  } else {
    if(shipping_local && shipping_local.handle) {
      check_local = shipping_local.handle;
    }
  }
  let html = '';
  COUNTRY_ALL_CODE.map(item => {
     let selected = '';
     if(check_local == item.handle) selected = 'selected'
      html += `<option value="` + item.handle + `" `+selected+` data-val="` + item.name + `">`;
      html += item.name;
      html += `</option>`;
  });
  $('.select-currencies').append(html);
}

setTimeout(getListCurrenciesBox, 2000);
  
function shopify_toggle_shipping_country() {
  $('.popup-shipping-country').toggleClass('hidden');
  $('.bg-country').toggleClass('hidden');
 // updateLocalization({country: "VN", language: "en"});
}

function update_shipping_country() {
   let country = $('.currencies-country').val();
   let currency = $('.select-currencies').val();
   window.localStorage.setItem('currencies_country', currency);
   updateLocalization({country: country});
}

function updateLocalization({country}) {
  const formId = crypto.randomUUID();
  const formHtml = `
    <form id="${formId}" action="/localization" method="POST" hidden>
      <input name="_method" value="PUT">
      <input name="country_code" value="${country}">
    </form>
  `;
  document.body.insertAdjacentHTML("beforeend", formHtml);
  document.getElementById(formId).submit();
}
